import { AppBar, Box, Divider, Toolbar, Typography } from '@mui/material';
import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';
import { NavDrawer } from './NavDrawer';
import { NotificationsBell } from './NotificationsBell';
import { UserMenu } from './UserMenu';

/**
 * docs/design/MUI-Komponenten.md "Shell": AppBar + Toolbar (BTC-Logo links,
 * Briefing Kapitel 7), Drawer permanent, Glocke, Nutzermenü. Offizielle
 * BTC-Logo-Datei ist laut Briefing Kapitel 10 "Offene Punkte" noch nicht
 * bereitgestellt -- Platzhalter-Text bis dahin.
 */
export function AppShell(): JSX.Element {
  return (
    <Box display="flex">
      <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h2" color="common.white" sx={{ mr: 2 }} data-testid="btc-logo-placeholder">
            BTC
          </Typography>
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)', mr: 2 }} />
          <Typography variant="subtitle1" color="common.white" sx={{ flexGrow: 1 }}>
            vigil
            <Typography component="span" variant="caption" color="rgba(255,255,255,0.7)" sx={{ ml: 1 }}>
              Monitor für Datenschutz- und Vertragsbedingungen
            </Typography>
          </Typography>
          <NotificationsBell />
          <UserMenu />
        </Toolbar>
      </AppBar>
      <NavDrawer />
      <Box component="main" flexGrow={1} p={3} mt="64px">
        <Outlet />
      </Box>
    </Box>
  );
}
